import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    link: {
      textDecoration: 'underline',
      color: STYLE.COLOR.ACCENT_PRIMARY,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
    },
    disabledLink: {
      color: STYLE.COLOR.TEXT2,
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  }),
);
